<template>
  <v-btn
    elevation="2"
    class="button-position d-flex align-center px-2 lightGold"
  >
    <v-icon @click="changRadius(1)" class="white--text">mdi-plus</v-icon>
    <span class="mx-3 black--text">{{
    `רדיוס נבחר - ${currentRadius} ק"מ`
    }}</span>
    <v-icon @click="changRadius(-1)" class="white--text">mdi-minus</v-icon>
  </v-btn>
</template>

<script>
import _ from "lodash"
export default {
  name: "RadiusButton",
  components: {},
  data() {
    return {}
  },
  computed: {
    currentRadius() {
      return this.$store.getters.currentRadius
    },
    points() {
      return this.$store.getters.pointsInRadius
    },
    point() {
      return this.$store.getters.point
    },
  },
  methods: {
    getPointsInRadius: _.debounce(function (newRadius) {
      const [lat, lng] = this.point?.location?.coordinates
      this.$store.dispatch("point/indexPointsInRadius", {
        radius: newRadius,
        lat,
        lng,
        toastOptions:{disabled:true}
      })
    }, 1500),
    changRadius(km){
      if (this.currentRadius === 1) return
      const newRadius = this.currentRadius + km
      this.$store.commit("point/currentRadiusSet", {
        currentRadius: newRadius,
      })
      this.getPointsInRadius(newRadius)
      this.$store.getters.circleOnMapInstance?.setRadius(newRadius * 1000)
    },
  },
}
</script>
<style lang="scss" scoped>
.button-position {
  position: fixed;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
}
</style>
